import { useParams } from "react-router";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { StructuralAssessmentsTable } from "@/services/backend/htz/report/components/structural-assessments-table";
import { ReportStructuralAssessmentAddDropdown } from "@/services/backend/htz/report/components/report-structural-assessment-add-dropdown";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";

export function StructuralRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!report) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Konstruktive Beurteilung")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die einzelnen konstruktiven Beurteilungen für die Bauteile angezeigt.",
          )}
        </CardDescription>
        <CardAction>
          <ReportStructuralAssessmentAddDropdown
            report={report}
            disabled={isImmutable(report)}
          />
        </CardAction>
      </CardHeader>
      <CardContent>
        <StructuralAssessmentsTable report={report} />
      </CardContent>
    </Card>
  );
}
